import React from "react";
import { Input } from "reactstrap";
import Textarea from "react-textarea-autosize";

const SSPuischema = {
    id: {
        "ui:widget": "hidden"
    },
    name: {
        "ui:widget": (props) => {
            return (
                <div>
                <span className="task-status icon ion-android-checkbox-blank" onClick={
                    () => {
                        props.formContext.submit({formData: {...props.formContext.formdata, status: "Closed"}});
                    }
                }/>
                    <Textarea className={props.schema.classes}
                              value={props.value} required={props.required}
                              placeholder={props.schema.placeholder} autoFocus={true}
                              onChange={(event) => {
                                  props.onChange(event.target.value)
                              }}/>
                </div>
            );
        },
        "classNames": 'task-title',
        "ui:autofocus": true
    },
    type: {
        "ui:placeholder": 'Select Type',
        "ui:enumDisabled": ['Select Type'],
    },
    customer: {
        "ui:widget": "hidden"
    },
    status: {
        "ui:widget": "hidden",
        "ui:readonly": true
    },
    estate: {
        "ui:readonly": false
    },
    account_code: {
        "ui:widget": (props) => {
            return <Input type="text" value={props.formContext.accountCode ? props.formContext.accountCode : ''} disabled selected/>
        },
    },
    mprn: {
        "ui:widget": (props) => {
            const options = props.formContext.customerMeterPoints.map((mp, i) => <option key={i} value={mp}>{mp}</option>);
            return <Input type="select" onChange={(event) => {
                props.onChange(event.target.value)
            }}>
                <option value=''></option>
                {options}
            </Input>
        }
    },
    priority: {
        "ui:widget": "hidden"
    },
    description: {
        "ui:widget": props => (
            <div><Textarea value={props.value ? props.value : ""} placeholder="Query Description"
                           minRows="10"
                           countLimit={4000}
                           onChange={(event) => {
                               props.onChange(event.target.value.substr(0, 4000))
                           }}
            />
                <div className="pull-right"> {props.value ? props.value.length : 0}/4000</div>
            </div>
        ),
        "classNames": 'description',
    },
    consumer_number: {
        "ui:widget": (props) => {
            const options = props.formContext.accounts.map((acc, i) => {
                if (props.formContext.properties[i] && props.formContext.properties[i].number) {
                    return <option key={i}
                        value={[props.formContext.properties[i].number, acc]}>{acc}</option>
                } else return null;
            });

            return <Input type="select" onChange={(event) => {
                const meterPoints = props.formContext.properties.filter(el => el.number === event.target.value.split(',')[0])
                    .flatMap(propertie => propertie && propertie.properties.flatMap(site => site.site.meterPoints.map(mprn => mprn.identifier)));

                props.formContext.handleChanges('customerMeterPoints', meterPoints);
                
                props.formContext.setAccount_code(event.target.value);
                props.onChange(event.target.value.split(',')[0]);
            }}>
                <option value=''></option>
                {options}
            </Input>
        }
    },
    closed_on: {
        "ui:readonly": true,
        "ui:widget": "hidden"
    },
    closed_by: {
        "ui:readonly": true,
        "ui:widget": "hidden"
    },
    "ui:order": ["id", "name", "type", "assignee", "customer", "status", "priority", 'contact_name', 'contact_number', 'contact_email', 'estate', 'consumer_number', 'account_code', 'mprn', 'description', 'closed_on', 'closed_by']
}

export default SSPuischema;